import * as React from "react";

const SvgIcnAlertTriangle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M12.446 4.07a1 1 0 01.448.45l6.992 14.034A1 1 0 0118.991 20H4.996a1 1 0 01-.894-1.446l7.002-14.035a1 1 0 011.342-.448zM12 15a1 1 0 100 2 1 1 0 000-2zm0-6a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z"
            fill="currentcolor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnAlertTriangle;
